/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BuyerInputs */

const en__field_buyer = /** @type {(inputs: _Field_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`buyer`)
};

const de__field_buyer = /** @type {(inputs: _Field_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer`)
};

/**
* | output |
* | --- |
* | "buyer" |
*
* @param {_Field_BuyerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_buyer = /** @type {((inputs?: _Field_BuyerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BuyerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_buyer(inputs)
	return de__field_buyer(inputs)
});